import { render, staticRenderFns } from "./dialogConfirmArchiving.vue?vue&type=template&id=65869804"
import script from "./dialogConfirmArchiving.vue?vue&type=script&lang=js"
export * from "./dialogConfirmArchiving.vue?vue&type=script&lang=js"
import style0 from "./dialogConfirmArchiving.vue?vue&type=style&index=0&id=65869804&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports